import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import {
  MenuBook as CourseIcon,
  Pattern as PatternIcon,
  Lightbulb as SolutionIcon,
  Psychology as SkillIcon,
  Image as ImageIcon,
  CalendarMonth as SessionIcon,
  Quiz as QuizIcon,
  EmojiEvents as ObjectiveIcon,
  OndemandVideo as VideoIcon,
  Person as TeacherIcon,
  AccountTree as SetupIcon,
} from '@mui/icons-material';
import SearchCourses from './SearchCourses';
import SearchTeachers from './SearchTeachers';
import SearchPatterns from './SearchPatterns';
import SearchSessions from './SearchSessions';
import SearchQuizzes from './SearchQuizzes';
import SearchSolutions from './SearchSolutions';
import SearchObjectives from './SearchObjectives';
import SearchSkills from './SearchSkills';
import SearchImages from './SearchImages';
import SearchVideos from './SearchVideos';
import SearchSetups from './SearchSetups';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`search-tabpanel-${index}`}
      aria-labelledby={`search-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const Search: React.FC = () => {
  const [tabValue, setTabValue] = useState(0); // Start on Courses tab

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const tabs = [
    { label: 'Cours', icon: <CourseIcon /> },
    { label: "Patterns d'exercices", icon: <PatternIcon /> },
    { label: 'Séances', icon: <SessionIcon /> },
    { label: 'Quizz', icon: <QuizIcon /> },
    { label: 'Solutions', icon: <SolutionIcon /> },
    { label: 'Objectifs', icon: <ObjectiveIcon /> },
    { label: 'Savoir-faire', icon: <SkillIcon /> },
    { label: 'Images', icon: <ImageIcon /> },
    { label: 'Vidéos', icon: <VideoIcon /> },
    { label: 'Setups', icon: <SetupIcon /> },
    { label: 'Enseignant', icon: <TeacherIcon /> },
  ];

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Recherche
      </Typography>

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="search tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab.label}
              label={tab.label}
              icon={tab.icon}
              iconPosition="start"
            />
          ))}
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <SearchCourses />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <SearchPatterns />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <SearchSessions />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <SearchQuizzes />
        </TabPanel>

        <TabPanel value={tabValue} index={4}>
          <SearchSolutions />
        </TabPanel>

        <TabPanel value={tabValue} index={5}>
          <SearchObjectives />
        </TabPanel>

        <TabPanel value={tabValue} index={6}>
          <SearchSkills />
        </TabPanel>

        <TabPanel value={tabValue} index={7}>
          <SearchImages />
        </TabPanel>

        <TabPanel value={tabValue} index={8}>
          <SearchVideos />
        </TabPanel>

        <TabPanel value={tabValue} index={9}>
          <SearchSetups />
        </TabPanel>

        <TabPanel value={tabValue} index={10}>
          <SearchTeachers />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default Search;
